import React, { SVGProps } from "react";

import { motion } from "framer-motion";
import styled from "styled-components";

export default function ArrowRight(props: SVGProps<SVGSVGElement>) {
  const iconMotion = {
    rest: { x: 0, scale: 1 },
    hover: { x: 3, scale: 1.0625 },
    tap: { x: 100, scale: 0.95 },
  };

  return (
    <IconWrapper
      initial="rest"
      whileHover="hover"
      whileTap="tap"
      animate="rest"
    >
      <svg
        width="11"
        height="10"
        viewBox="0 0 11 10"
        {...props}
        style={{ overflow: "visible" }}
      >
        <StyledPath
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.64007 1.53697L8.0606 4.09174L0.837498 4.12698C0.614275 4.12787 0.400549 4.22353 0.243444 4.39288C0.08634 4.56224 -0.00124073 4.79136 1.23978e-05 5.02975C0.0010519 5.26799 0.090724 5.49602 0.249279 5.66362C0.407835 5.83121 0.62227 5.92463 0.845354 5.92329L8.06688 5.88889L5.67856 8.46967C5.52135 8.63872 5.43351 8.86758 5.43439 9.10584C5.43528 9.3441 5.52481 9.57221 5.68328 9.73993C6.0136 10.089 6.54622 10.0863 6.87351 9.73405L10.8017 5.49791C11.0691 5.20761 11.0656 4.74071 10.7938 4.45503L6.82401 0.260002C6.49396 -0.0889478 5.96158 -0.0863191 5.63457 0.265876C5.47741 0.435182 5.38969 0.664244 5.39072 0.902639C5.39175 1.14103 5.48145 1.36922 5.64007 1.53697Z"
          fill={props.fill}
          variants={iconMotion}
        />
      </svg>
    </IconWrapper>
  );
}

const IconWrapper = styled(motion.div)`
  cursor: pointer;
`;

const StyledPath = styled(motion.path)`
  fill: ${({ theme }) => theme.colors.icon};
`;
